import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'quiz-count-down',
    templateUrl: './quiz-count-down.component.html',
    styleUrls: ['./quiz-count-down.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuizCountDownComponent implements OnInit {
    @Input() maxCount: number = 3;
    @Input() countTime: number = 1000;

    @Output() countDownDone = new EventEmitter<void>();

    public countDownList: string[] = [];
    public showCountIdx: number = -1;

    constructor(private cd: ChangeDetectorRef) { }

    ngOnInit(): void {
        // Generate count down labels
        for(let count = 0; count <= this.maxCount; count++) {
            let label = (count == 0) ? $localize`GO!` : count.toString();
            this.countDownList.push(label);
        }
        this.startCountDown();
    }

    private startCountDown() {
        // Init show count idx one higher than idx to add 1 sec animation time before countdown 
        this.showCountIdx = this.maxCount + 1;
        // Start count down interval
        let countDownInterval = setInterval(() => {
            // Check if animation is done
            if(this.showCountIdx <= 0) {
                clearInterval(countDownInterval);
                // Close this component
                this.countDownDone.emit();
                return;
            }
            // Decrease animation counter (show next label)
            this.showCountIdx--;
            // Mark for check, as change detection does not handle setInterval as an event without apparently 
            // (and will not update the view if the component is placed inside another component without it)
            this.cd.markForCheck();
        }, this.countTime);
    }
}
